import { GlobalErrorActions, GlobalErrorActionTypes, GlobalErrorState } from "store/types/globalError";

const initialState: GlobalErrorState = {
    message: null
}

const errorReducer = (state = initialState, action: GlobalErrorActions) => {
    switch (action.type) {
        case GlobalErrorActionTypes.SET_ERROR:
            return { ...state, message: action.payload };
        case GlobalErrorActionTypes.CLEAR_ERROR:
            return { ...state, message: null };
        default:
            return state;
    }
}

export default errorReducer;